import { Navigate } from 'react-router';

import { useTypedParams } from '@sorare/routing';
import {
  ANY_SPORT_HOME,
  ANY_SPORT_PLAY_EVENTTYPE_CHAMPIONSHIP_USERGROUP_USER,
} from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import type { PageParams } from './__generated__/routeParams.ts';
import { useChampionshipLayoutData } from './layout.tsx';

const ChampionshipPage = () => {
  const { currentUser } = useCurrentUserContext();
  const { eventType } = useTypedParams<PageParams>();
  const { generateSportContextPath } = useSportContext();

  const { so5UserGroupSlug } = useChampionshipLayoutData();

  if (!so5UserGroupSlug) {
    return <Navigate to={generateSportContextPath(ANY_SPORT_HOME)} replace />;
  }

  return (
    <Navigate
      to={generateSportContextPath(
        ANY_SPORT_PLAY_EVENTTYPE_CHAMPIONSHIP_USERGROUP_USER,
        {
          params: {
            user: currentUser?.slug ?? '',
            userGroup: so5UserGroupSlug,
            eventType: eventType.toLowerCase(),
          },
        }
      )}
      replace
    />
  );
};

export default ChampionshipPage;
